import { IBundle, IBundleFeedback } from '../../../../model/options/IBundle';
import { requests } from '../../../../utils';
import { BUNDLE_URL } from '../../../../utils/endpoints';

export const OptionService = {
    sendComment: (bundleId: number, message: string) =>
        requests.post(`${BUNDLE_URL}/comment/send`, {
            bundleId,
            message,
        }),
    getBundle: (id: string, resetDot?: boolean): Promise<IBundle> => requests.get(`${BUNDLE_URL}/${id}`, { resetDot }),
    sendFeedback: (body: IBundleFeedback) => requests.post(`${BUNDLE_URL}/feedback`, body),
    uploadFile: (formData: FormData, bundleId: number) =>
        requests.post(`${BUNDLE_URL}/attachment/${bundleId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }),
    deleteFile: (fileId: string) => requests.delete(`${BUNDLE_URL}/attachment/${fileId}`),
};
